import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';
// @ts-expect-error
import type {RouterHistory} from 'react-router-dom';

import {Link} from 'shells/link/link';
import {NavButtons, RightFrame, ModalMain} from 'shells/modal/step-modal/layout';
import {ModalHeader} from 'shells/typography/modal-header';

import {SELECT_METHOD, VERIFY_SMS} from '../constants';
import {VerifySmsPhoneScreen} from '../screens/verify-sms-phone-screen';

type Props = {
    history: RouterHistory;
    handlePhoneNumber: (arg1: string) => void;
    prefilledPhoneNumber?: string;
};

export function VerifySmsPhone(props: Props) {
    return (
        <RightFrame>
            <ModalMain>
                <ModalHeader>Verify Method</ModalHeader>
                <VerifySmsPhoneScreen
                    goNext={() => {
                        props.history.push(VERIFY_SMS);
                    }}
                    handlePhoneNumber={props.handlePhoneNumber}
                    prefilledPhoneNumber={props.prefilledPhoneNumber}
                />
            </ModalMain>

            <NavButtons style={{justifyContent: 'flex-start'}}>
                <React.Fragment>
                    {/* @ts-expect-error */}
                    <Link variant='primary' size='big' as={RoutedLink} to={SELECT_METHOD}>
                        Back
                    </Link>
                </React.Fragment>
            </NavButtons>
        </RightFrame>
    );
}
